import { render } from "./CandidateActionLayout.vue?vue&type=template&id=855cf554"
import script from "./CandidateActionLayout.vue?vue&type=script&lang=js"
export * from "./CandidateActionLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__